import React from "react";

import { Helmet } from "react-helmet";

import FeatureCard from "../components/feature-card";
import Question1 from "../components/question1";
import "./home.css";

const Home = (props) => {
  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };
  return (
    <div className="home-container">
      <Helmet>
        <title>Well Lit Apt Grasshopper</title>
        <meta property="og:title" content="Well Lit Apt Grasshopper" />
      </Helmet>
      <div className="home-header">
        <header
          data-thq="thq-navbar"
          className="navbarContainer home-navbar-interactive"
        >
          <span className="logo">Wholistic Wellness</span>
          <div data-thq="thq-navbar-nav" className="home-desktop-menu">
            <nav className="home-links">
              <span className="home-nav62 bodySmall" onClick={scrollToBottom}>
                Contact Us
              </span>
            </nav>
          </div>
          <div data-thq="thq-burger-menu" className="home-burger-menu"></div>
          <div
            data-thq="thq-mobile-menu"
            className="home-mobile-menu1 mobileMenu"
          >
            <div className="home-nav">
              <div className="home-top">
                <span className="logo">PHYSIOYOGA</span>
                <div data-thq="thq-close-menu" className="home-close-menu">
                  <svg
                    viewBox="0 0 1024 1024"
                    className="home-icon socialIcons"
                  >
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              <nav className="home-links1">
                <span className="home-nav12 bodySmall">Home</span>
                <span className="home-nav22 bodySmall">About Us</span>
                <span className="home-nav32 bodySmall">Services</span>
                <span className="home-nav42 bodySmall">Yoga Plans</span>
                <span className="home-nav52 bodySmall">
                  Physiotherapy Treatments
                </span>
                <span className="home-nav621 bodySmall">Contact Us</span>
              </nav>
              <div className="home-buttons">
                <button className="buttonFlat">Login</button>
                <button className="buttonFilled">Register</button>
              </div>
            </div>
            <div>
              <svg
                viewBox="0 0 950.8571428571428 1024"
                className="home-icon02 socialIcons"
              >
                <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
              </svg>
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="home-icon04 socialIcons"
              >
                <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
              </svg>
              <svg
                viewBox="0 0 602.2582857142856 1024"
                className="home-icon06 socialIcons"
              >
                <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
              </svg>
            </div>
          </div>
        </header>
      </div>
      <div className="home-hero">
        <div className="heroContainer home-hero1">
          <div className="home-container01">
            <h3 className="home-hero-heading heading1">
              Welcome to our Physiotherapy and Yoga Studio
            </h3>
            <span className="home-hero-sub-heading bodyLarge">
              <span>Experience the power of healing through movement</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </span>
            <div className="home-btn-group">
              <a
                className="buttonFilled"
                href="https://wa.me/+918448302577?text=Hello,%20I%20have%20an%20enquiry."
                target="_blank"
              >
                Book a Session
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="home-features">
        <div className="featuresContainer">
          <div className="home-features1">
            <div className="home-container02">
              <span className="overline">
                <span>features</span>
                <br></br>
              </span>
              <h2 className="home-features-heading heading2">
                Our Key Features
              </h2>
              <span className="home-features-sub-heading bodyLarge">
                <span>
                  <span>
                    <span>
                      Discover what sets our physiotherapy and Yoga studio apart
                    </span>
                    <span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: " ",
                        }}
                      />
                    </span>
                  </span>
                  <span>
                    <span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: " ",
                        }}
                      />
                    </span>
                    <span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: " ",
                        }}
                      />
                    </span>
                  </span>
                </span>
                <span>
                  <span>
                    <span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: " ",
                        }}
                      />
                    </span>
                    <span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: " ",
                        }}
                      />
                    </span>
                  </span>
                  <span>
                    <span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: " ",
                        }}
                      />
                    </span>
                    <span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: " ",
                        }}
                      />
                    </span>
                  </span>
                </span>
              </span>
            </div>
            <div className="home-container03">
              <FeatureCard
                heading="Customized Treatment Plans"
                subHeading="Tailored physiotherapy plans to meet individual needs"
              ></FeatureCard>
              <FeatureCard
                heading="Experienced Therapists"
                subHeading="Highly skilled and experienced physiotherapists and Yoga instructors"
              ></FeatureCard>
              <FeatureCard
                heading="Advanced Modalities"
                subHeading="Utilizing the latest techniques and equipment for effective treatment"
              ></FeatureCard>
              <FeatureCard
                heading="Monthly Yoga Plans"
                subHeading="Access to unlimited Yoga classes with flexible monthly plans"
              ></FeatureCard>
            </div>
          </div>
        </div>
      </div>
      <div className="home-pricing">
        <div className="pricingContainer">
          <div className="home-container04">
            <span className="overline">
              <span>Pricing</span>
              <br></br>
            </span>
            <h2 className="heading2">Choose Your Yoga Plan</h2>
            <span className="home-pricing-sub-heading bodyLarge">
              <span>
                <span>
                  Select the plan that best suits your needs for a healthier
                  lifestyle.
                </span>
              </span>
            </span>
          </div>
          <div className="home-container05">
            <div className="basicPricingCard home-pricing-card">
              <div className="home-container06">
                <span className="home-text30 heading3">Monthly</span>
                <span className="bodySmall">
                  Enhanced physiotherapy treatments and more yoga classes
                </span>
              </div>
              <div className="home-container07">
                <span className="home-text31">₹</span>
                <span className="home-basic-plan-pricing">2000</span>
                <span className="home-text32">/ month</span>
              </div>
              <div className="home-container08">
                <div className="home-container09">
                  <span className="home-text33">✔</span>
                  <span className="bodySmall">Daily Yoga Sessions</span>
                </div>
                <div className="home-container10">
                  <span className="home-text35">✔</span>
                  <span className="bodySmall">Access to gym equipment</span>
                </div>
                <div className="home-container11">
                  <span className="home-text36">✔</span>
                  <span className="bodySmall">
                    Access to treadmills and cycling machines 
                  </span>
                </div>
                <div className="home-container12">
                  <span className="home-text37">✔</span>
                  <span className="bodySmall">
                    Access to special zumba classes
                  </span>
                </div>
              </div>
              <a
                className="home-button buttonFilledSecondary"
                href="https://wa.me/+918448302577?text=Hello,%20I%20have%20an%20enquiry."
                target="_blank"
              >
                Try the Basic plan
              </a>
            </div>
            <div className="proPricingCard home-pricing-card1">
              <div className="home-container13">
                <span className="home-text38 heading3">
                  <span>Yearly</span>
                  <br></br>
                </span>
                <span className="bodySmall">
                  Comprehensive physiotherapy care and unlimited yoga classes
                </span>
              </div>
              <div className="home-container14">
                <span className="home-text41">₹</span>
                <span className="home-pro-plan-pricing">1500</span>
                <span className="home-text42">
                  <span>/ month</span>
                  <br></br>
                </span>
              </div>
              <div className="home-container15">
                <div className="home-container16">
                  <span className="home-text45">✔</span>
                  <span className="bodySmall"> Daily Yoga Sessions</span>
                </div>
                <div className="home-container17">
                  <span className="home-text47">✔</span>
                  <span className="bodySmall">
                    1 FREE physiotherapy session every month
                  </span>
                </div>
                <div className="home-container18">
                  <span className="home-text48">✔</span>
                  <span>Access to treadmills and cycling machines </span>
                </div>
                <div className="home-container19">
                  <span className="home-text49">✔</span>
                  <span className="bodySmall">
                    Personalized physiotherapy and yoga plan
                  </span>
                </div>
              </div>
              <a
                className="home-button1 buttonFilledSecondary"
                href="https://wa.me/+918448302577?text=Hello,%20I%20have%20an%20enquiry."
                target="_blank"
              >
                Try the PRO plan
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="home-banner">
        <div className="bannerContainer home-banner1">
          <h1 className="home-banner-heading heading2">
            Transform Your Health with Our Services
          </h1>
          <span className="home-banner-sub-heading bodySmall">
            <span>
              <span>
                <span>
                  Our physiotherapy clinic offers a wide range of treatments to
                  help you recover from injuries and improve your overall
                  well-being. Our Yoga studio provides monthly plans to help you
                  maintain a healthy lifestyle. Discover the perfect balance of
                  mind and body with us.
                </span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
              </span>
              <span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
              </span>
            </span>
            <span>
              <span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
              </span>
              <span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
              </span>
            </span>
          </span>
          <a
            className="buttonFilled"
            href="https://wa.me/+918448302577?text=Hello,%20I%20have%20an%20enquiry."
            target="_blank"
          >
            Learn More
          </a>
        </div>
      </div>
      <div className="home-faq">
        <div className="faqContainer">
          <div className="home-faq1">
            <div className="home-container20">
              <h3 className="home-text64 heading2">FAQs</h3>
              <span className="home-text65 bodyLarge">
                <span>
                  Here are some of the most common questions that we get.
                </span>
                <br></br>
              </span>
            </div>
            <div className="home-container21">
              <Question1
                answer="Physiotherapy can help reduce pain, improve mobility, and enhance overall quality of life."
                question="What are the benefits of physiotherapy?"
              ></Question1>
              <Question1
                answer="The frequency of sessions will depend on your condition and the treatment plan recommended by your physiotherapist."
                question="How often should I attend physiotherapy sessions?"
              ></Question1>
              <Question1
                answer="The studio offers a variety of yoga classes including Hatha, Vinyasa, Ashtanga, and Yin yoga."
                question="What types of yoga classes are offered in the studio?"
              ></Question1>
              <Question1
                answer="Yes, combining physiotherapy and yoga can be beneficial as they complement each other in promoting physical and mental well-being."
                question="Can I combine physiotherapy and yoga for my treatment?"
              ></Question1>
              <Question1
                answer="Yes, the studio offers discounts for long-term monthly yoga plans. Please inquire at the studio for more details."
                question="Are there any discounts available for monthly yoga plans?"
              ></Question1>
            </div>
          </div>
        </div>
      </div>
      <div className="home-footer">
        <footer className="footerContainer home-footer1">
          <div className="home-container22">
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.7697713268726!2d77.01483978755914!3d28.456355829575145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d195a74fb6003%3A0x5b71d97611d41861!2sWholistic%20Wellness%20Physiotherapy%20and%20Yoga%20center!5e0!3m2!1sen!2suk!4v1708734436989!5m2!1sen!2suk" width="400" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade'
              className="home-iframe"
            ></iframe>
            <span className="home-logo2">
              <span className="home-text68">Address</span>
              <br></br>
              <br></br>
              <span>335/4, Model Town, Sector 11</span>
              <br></br>
              <span>Gurgaon, Haryana - 122001</span>
              <br></br>
              <br></br>
              <span>+91 8448302577</span>
              <br></br>
            </span>
          </div>
          <div className="home-separator"></div>
          <div className="home-container23">
            <span className="bodySmall home-text78">
              © 2024 Wholistic Wellness, All Rights Reserved.
            </span>
            <div className="home-icon-group1">
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="home-icon08 socialIcons"
              >
                <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
              </svg>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Home;
